import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGermany = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffda44",
			d: "M16 345a256 256 0 0 0 480 0l-240-22.2z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M256 0A256 256 0 0 0 16 167l240 22.2L496 167A256 256 0 0 0 256 0z" }),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M16 167a255.5 255.5 0 0 0 0 178h480a255.4 255.4 0 0 0 0-178z"
		})
	]
});
export default SvgGermany;
